'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _ja;

import TitleTypes from '../constants/TitleTypes';
export default {
  ja: (_ja = {}, _defineProperty(_ja, TitleTypes.COMPANY, function (name) {
    return name + " \u5FA1\u4E2D";
  }), _defineProperty(_ja, TitleTypes.CUSTOMER, function (name) {
    return name + " \u69D8";
  }), _ja)
};